export default "__VITE_ASSET__DfNOR0rt__"